import { render, staticRenderFns } from "./BunchOutput.vue?vue&type=template&id=38b59900&scoped=true&functional=true"
import script from "./BunchOutput.vue?vue&type=script&lang=js"
export * from "./BunchOutput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "38b59900",
  null
  
)

export default component.exports